import { QueryClient } from 'react-query';
import { TSavedAddons } from './useAddonFlowMobile.models';

export const getReferenceId = (addonMecId: string, data: any) => {
  const productAddonsArray = data?.mobileOfferingConfiguration?.bundledAddOnGroupConfiguration?.map(
    (el) => el?.bundledAddOnConfiguration
  );
  const flatAddonsArray = productAddonsArray?.flat();
  const addon = flatAddonsArray?.find((el: any) => el?.offeringId === addonMecId);
  const referenceId =
    addon?.addOnOfferingConfiguration?.[0]?.productSpecificationConfiguration?.referenceId || null;

  return referenceId;
};

export const saveAddonOnQueryClient = (
  queryClient: QueryClient,
  addonId: string,
  referenceId: string
) => {
  const savedAddons =
    (queryClient.getQueryData('SavedAddons') as Record<string, TSavedAddons>) || {};
  queryClient.setQueryData('SavedAddons', {
    ...savedAddons,
    [addonId]: {
      referenceId,
    },
  });
};

export const removeAddonFromQueryClient = (queryClient: QueryClient, addonId: string) => {
  const savedAddons =
    (queryClient.getQueryData('SavedAddons') as Record<string, TSavedAddons>) || {};

  if (savedAddons[addonId]) {
    const { [addonId]: _, ...updatedAddons } = savedAddons;
    queryClient.setQueryData('SavedAddons', updatedAddons);
  }
};

export const getReferenceIdFromQueryClient = (
  queryClient: QueryClient,
  addonId: string
): string => {
  const savedAddons = queryClient.getQueryData('SavedAddons') as Record<string, TSavedAddons>;
  return savedAddons?.[addonId]?.referenceId || '';
};

